import Navbar from "../../components/shared/Navbar";
import Footer from "../../components/shared/Footer";
import RightBar from "../../components/shared/RightBar";
import BreadCrumbGallery from "../../components/gallery/BreadCrumbGalley";
import Detail from "../../components/gallery/Detail";

export default function Gallery() {
    return (
        <div className="flex flex-col min-h-screen">
            <Navbar />
            <RightBar></RightBar>
            <main className="flex-grow">
                <BreadCrumbGallery></BreadCrumbGallery>
                <Detail></Detail>
            </main>
            <Footer />
        </div>
    )
}